import React from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";
import InputField from "../../../lib/components/InputField";
import RenderTextField from "lib/components/RenderTextField";
import { presence } from "../../../shared/validations";
import { styleModules } from "shared/ui/material-ui-styles/use-style-imputs";
import { withStyles } from "@mui/styles";

class CustomInput extends React.Component {
  render() {
    const { wrapperClassName, customField, isEmbedded, classes } = this.props;

    const isRequired = customField.get("required") === true;
    const className = isRequired ? "required-field" : null;

    if (!isEmbedded) {
      return (
        <div className={wrapperClassName}>
          <label className={className} htmlFor={customField.get("name")}>
            {customField.get("label")}
          </label>
          <Field
            aria-label={customField.get("label")}
            className="p-sm-b"
            name={`custom_fields_hash.${customField.get("name")}`}
            component={InputField}
            validate={isRequired ? [presence] : null}
            type="text"
          />
        </div>
      );
    } else {
      return (
        <div className={wrapperClassName}>
          <Field
            variant="outlined"
            name={`custom_fields_hash.${customField.get("name")}`}
            component={RenderTextField}
            formControlClass={classes.controlRootInput}
            className={classes.textField}
            placeholder={
              isRequired ? `*${customField.get("label")}` : customField.get("label")
            }
            type="text"
            InputProps={{
              className: classes.input,
            }}
            validate={isRequired ? [presence] : null}
          />
        </div>
      );
    }
  }
}

CustomInput.propTypes = {
  classes: PropTypes.object,
};

export default withStyles(styleModules)(CustomInput);
